import React from 'react';

export interface LiveEventMetricCardsProps {
    totalEvents: number;
    totalEventsSubtext: string;
    totalAttendees: number;
    totalAttendeesSubtext: string;
    avgShowRatePercent: number;
    avgShowRateSubtext: string;
    eventToRedemptionPercent: number;
    eventToRedemptionSubtext: string;
}

const ICON_COLOR = '#34D399';

// Total Events (user-provided SVG)
const TotalEventsIcon = () => (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M10.666 7.33333L11.9993 8.66667L14.666 6" stroke={ICON_COLOR} strokeWidth="1.33333" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M10.6673 14V12.6667C10.6673 11.9594 10.3864 11.2811 9.88627 10.781C9.38617 10.281 8.7079 10 8.00065 10H4.00065C3.29341 10 2.61513 10.281 2.11503 10.781C1.61494 11.2811 1.33398 11.9594 1.33398 12.6667V14" stroke={ICON_COLOR} strokeWidth="1.33333" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M6.00065 7.33333C7.47341 7.33333 8.66732 6.13943 8.66732 4.66667C8.66732 3.19391 7.47341 2 6.00065 2C4.52789 2 3.33398 3.19391 3.33398 4.66667C3.33398 6.13943 4.52789 7.33333 6.00065 7.33333Z" stroke={ICON_COLOR} strokeWidth="1.33333" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
);

// Total Attendees (user-provided SVG)
const TotalAttendeesIcon = () => (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M10.6673 14V12.6667C10.6673 11.9594 10.3864 11.2811 9.88627 10.781C9.38617 10.281 8.7079 10 8.00065 10H4.00065C3.29341 10 2.61513 10.281 2.11503 10.781C1.61494 11.2811 1.33398 11.9594 1.33398 12.6667V14" stroke={ICON_COLOR} strokeWidth="1.33333" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M10.666 2.08545C11.2379 2.2337 11.7443 2.56763 12.1058 3.03482C12.4673 3.50202 12.6635 4.07604 12.6635 4.66678C12.6635 5.25752 12.4673 5.83154 12.1058 6.29874C11.7443 6.76594 11.2379 7.09987 10.666 7.24812" stroke={ICON_COLOR} strokeWidth="1.33333" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M14.666 13.9998V12.6664C14.6656 12.0756 14.4689 11.5016 14.1069 11.0346C13.7449 10.5677 13.2381 10.2341 12.666 10.0864" stroke={ICON_COLOR} strokeWidth="1.33333" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M6.00065 7.33333C7.47341 7.33333 8.66732 6.13943 8.66732 4.66667C8.66732 3.19391 7.47341 2 6.00065 2C4.52789 2 3.33398 3.19391 3.33398 4.66667C3.33398 6.13943 4.52789 7.33333 6.00065 7.33333Z" stroke={ICON_COLOR} strokeWidth="1.33333" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
);

// Avg. Show Rate (user-provided SVG)
const AvgShowRateIcon = () => (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M8.00065 14.6668C11.6825 14.6668 14.6673 11.6821 14.6673 8.00016C14.6673 4.31826 11.6825 1.3335 8.00065 1.3335C4.31875 1.3335 1.33398 4.31826 1.33398 8.00016C1.33398 11.6821 4.31875 14.6668 8.00065 14.6668Z" stroke={ICON_COLOR} strokeWidth="1.33333" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M8 12C10.2091 12 12 10.2091 12 8C12 5.79086 10.2091 4 8 4C5.79086 4 4 5.79086 4 8C4 10.2091 5.79086 12 8 12Z" stroke={ICON_COLOR} strokeWidth="1.33333" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M7.99935 9.33317C8.73573 9.33317 9.33268 8.73622 9.33268 7.99984C9.33268 7.26346 8.73573 6.6665 7.99935 6.6665C7.26297 6.6665 6.66602 7.26346 6.66602 7.99984C6.66602 8.73622 7.26297 9.33317 7.99935 9.33317Z" stroke={ICON_COLOR} strokeWidth="1.33333" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
);

// Event-to-Redemption Rate (user-provided SVG)
const EventToRedemptionIcon = () => (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M10.666 4.6665H14.666V8.6665" stroke={ICON_COLOR} strokeWidth="1.33333" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M14.6673 4.6665L9.00065 10.3332L5.66732 6.99984L1.33398 11.3332" stroke={ICON_COLOR} strokeWidth="1.33333" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
);

const Card: React.FC<{
    label: string;
    value: React.ReactNode;
    subtext: string;
    icon: React.ReactNode;
}> = ({ label, value, subtext, icon }) => (
    <div
        className="flex-1 min-w-[200px] flex flex-col"
        style={{
            flex: '1 1 0',
            minWidth: '200px',
            flexDirection: 'column',
            justifyContent: 'flex-start',
            alignItems: 'flex-start',
            display: 'inline-flex',
        }}
    >
        <div
            className="w-full p-[16.80px] bg-white dark:bg-gray-800 rounded-[8px] flex flex-col gap-[4px] outline outline-1 outline-[#E5E7EB] dark:outline-gray-700 outline-offset-[-1px]"
            style={{
                alignSelf: 'stretch',
                boxShadow: '0px 1px 2px rgba(0, 0, 0, 0.05)',
            }}
        >
            <div className="w-full flex justify-between items-start">
                <div
                    className="text-[#111827] dark:text-white text-[14px] font-semibold leading-[20px]"
                    style={{ fontFamily: 'Nunito' }}
                >
                    {label}
                </div>
                <div
                    className="w-8 h-8 rounded-[8px] flex items-center justify-center shrink-0 bg-[#F2FCFA] dark:bg-emerald-950/40"
                >
                    {icon}
                </div>
            </div>
            <div className="w-full flex flex-col gap-[4.40px]">
                <div
                    className="text-[#111827] dark:text-white text-[24px] font-bold leading-[32px]"
                    style={{ fontFamily: 'Nunito' }}
                >
                    {value}
                </div>
                <div
                    className="w-full text-[#4B5563] dark:text-gray-400 text-[12px] font-normal leading-[16px]"
                    style={{ fontFamily: 'Nunito' }}
                >
                    {subtext}
                </div>
            </div>
        </div>
    </div>
);

export const LiveEventMetricCards: React.FC<LiveEventMetricCardsProps> = ({
    totalEvents,
    totalEventsSubtext,
    totalAttendees,
    totalAttendeesSubtext,
    avgShowRatePercent,
    avgShowRateSubtext,
    eventToRedemptionPercent,
    eventToRedemptionSubtext,
}) => {
    return (
        <div
            className="w-full overflow-hidden flex flex-wrap justify-center items-center gap-4"
            style={{
                alignSelf: 'stretch',
                overflow: 'hidden',
                justifyContent: 'center',
                alignItems: 'center',
                gap: '16px',
                display: 'inline-flex',
                flexWrap: 'wrap',
            }}
        >
            <Card
                label="Total Events"
                value={totalEvents}
                subtext={totalEventsSubtext}
                icon={<TotalEventsIcon />}
            />
            <Card
                label="Total Attendees"
                value={totalAttendees}
                subtext={totalAttendeesSubtext}
                icon={<TotalAttendeesIcon />}
            />
            <Card
                label="Avg. Show Rate"
                value={`${avgShowRatePercent}%`}
                subtext={avgShowRateSubtext}
                icon={<AvgShowRateIcon />}
            />
            <Card
                label="Event-to-Redemption Rate"
                value={`${eventToRedemptionPercent}%`}
                subtext={eventToRedemptionSubtext}
                icon={<EventToRedemptionIcon />}
            />
        </div>
    );
};
